export const setSearch = item => {
  return {
    type: "SET_SEARCH",
    obj: item
  };
};
